/* Warehouse owns the main toggle; this controller owns its custom category panels. */
(function () {
  if (window.__ffMobileNavDrawer) return;
  window.__ffMobileNavDrawer = true;

  var menu, observer, wasOpen = false;
  var inertElements = [];
  var mobile = window.matchMedia('(max-width: 999px)');

  function toggle() {
    return document.querySelector('.header__mobile-nav-toggle[aria-controls="mobile-menu"]');
  }

  function positionDrawer() {
    if (!menu || !wasOpen) return;
    var header = menu.closest('.header');
    var bar = header && header.querySelector('.header__inner');
    if (bar) menu.style.setProperty('--ff-mobile-drawer-top', Math.max(0, Math.round(bar.getBoundingClientRect().bottom)) + 'px');
  }

  function showPanel(name, returning) {
    if (!menu) return;
    var previous = menu.querySelector('[data-ff-mobile-panel][aria-hidden="false"]');
    var previousName = previous && previous.dataset.ffMobilePanel;
    var panel = name && menu.querySelector('[data-ff-mobile-panel="' + name + '"]');
    menu.classList.toggle('ff-mobile-nav--subpanel-open', Boolean(panel));
    menu.querySelectorAll('[data-ff-mobile-panel]').forEach(function (item) {
      item.setAttribute('aria-hidden', item === panel ? 'false' : 'true');
    });
    menu.querySelectorAll('[data-ff-mobile-panel-open]').forEach(function (item) {
      item.setAttribute('aria-expanded', item.dataset.ffMobilePanelOpen === name ? 'true' : 'false');
    });
    if (panel && !returning) panel.scrollTop = 0;
    var focusTarget = returning && previousName
      ? menu.querySelector('[data-ff-mobile-panel-open="' + previousName + '"]')
      : panel && panel.querySelector('[data-ff-mobile-panel-close]');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function restorePage() {
    inertElements.forEach(function (element) { element.inert = false; });
    inertElements = [];
    document.documentElement.classList.remove('ff-mobile-nav-is-open');
    document.body.classList.remove('ff-mobile-nav-is-open');
  }

  function sync() {
    var isOpen = menu && menu.getAttribute('aria-hidden') === 'false';
    var trigger = toggle();
    if (trigger) trigger.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    if (isOpen === wasOpen) return;
    wasOpen = isOpen;
    if (isOpen) {
      document.querySelectorAll('main, [role="main"], footer:not(.ff-mobile-nav__assist)').forEach(function (element) {
        if (!element.closest('#mobile-menu') && !element.inert) {
          element.inert = true;
          inertElements.push(element);
        }
      });
      document.documentElement.classList.add('ff-mobile-nav-is-open');
      document.body.classList.add('ff-mobile-nav-is-open');
      positionDrawer();
      var first = menu.querySelector('[data-ff-mobile-panel-open]');
      if (first) first.focus({ preventScroll: true });
    } else {
      var restoreFocus = menu.contains(document.activeElement) || document.activeElement === trigger;
      showPanel(null, false);
      restorePage();
      if (restoreFocus && trigger && trigger.getClientRects().length) trigger.focus({ preventScroll: true });
    }
  }

  function close() {
    var trigger = toggle();
    // Use Warehouse's toggle so its internal state and scroll lock stay in sync.
    if (trigger && trigger.getAttribute('aria-expanded') === 'true') trigger.click();
    sync();
  }

  function init() {
    var next = document.getElementById('mobile-menu');
    if (next === menu) return;
    if (observer) observer.disconnect();
    restorePage();
    wasOpen = false;
    menu = next;
    if (!menu) return;
    observer = new MutationObserver(sync);
    observer.observe(menu, { attributes: true, attributeFilter: ['aria-hidden'] });
    sync();
  }

  // Search and basket handlers may stop bubbling; close the drawer before
  // another header control opens its own overlay.
  window.addEventListener('click', function (event) {
    if (wasOpen && !event.target.closest('.header__mobile-nav')) close();
  }, true);

  document.addEventListener('click', function (event) {
    if (!menu || !menu.contains(event.target)) return;
    var open = event.target.closest('[data-ff-mobile-panel-open]');
    var back = event.target.closest('[data-ff-mobile-panel-close]');
    if (open) {
      event.preventDefault();
      showPanel(open.dataset.ffMobilePanelOpen, false);
    } else if (back) {
      event.preventDefault();
      showPanel(back.dataset.ffMobilePanelBack || null, true);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!wasOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
    } else if (event.key === 'Tab') {
      var scope = menu.closest('.header__mobile-nav');
      var items = Array.from(scope.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')).filter(function (item) {
        return item.getClientRects().length && !item.closest('[aria-hidden="true"]');
      });
      var index = items.indexOf(document.activeElement);
      if (index === -1 || (event.shiftKey && index === 0) || (!event.shiftKey && index === items.length - 1)) {
        event.preventDefault();
        items[event.shiftKey ? items.length - 1 : 0].focus();
      }
    }
  });

  window.addEventListener('resize', function () {
    if (!mobile.matches) close();
    else positionDrawer();
  });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', positionDrawer);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    if (menu && event.target.contains(menu)) close();
  });
  init();
})();
